import { createContext, useState } from 'react';

export const RequestAnalysisInfoHook = () => {
  const [platform, setPlatform] = useState('android');
  const [numberOfSubmissions, setNumberOfSubmissions] = useState(0);

  return {
    platform,
    setPlatform,
    numberOfSubmissions,
    setNumberOfSubmissions,
  };
};

export const RequestAnalysisInfoContext = createContext(undefined);
